import { render } from "./ImageView.vue?vue&type=template&id=5071cce3&scoped=true"
import script from "./_ImageView.js?vue&type=script&lang=js&external"
export * from "./_ImageView.js?vue&type=script&lang=js&external"

import "./_ImageView.less?vue&type=style&index=0&id=5071cce3&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5071cce3"]])

export default __exports__